/**
 * Contains public information about a script
 */
export default class EQScript {

    /**
     *
     * @param {number} key the script ID
     * @param {string} label the script label from configuration
     */
    constructor(key, label, iterations, steps, gpsEnabled) {
        this.key = key;
        this.label = label;
        this.iterations = iterations;
        this.steps = steps;
        this.gpsEnabled = gpsEnabled;
    }
}



// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQScript.js